const WEIGHED_STATUS = 'weighed'
export const GRAMS_ROUNDING_FACTOR = 100

function hasValue (value) {
  return value !== null && value !== undefined
}

export function roundDownToGram (grams) {
  return Math.floor(Math.round(Number(grams) * GRAMS_ROUNDING_FACTOR) / GRAMS_ROUNDING_FACTOR)
}

function isWeighed (group) {
  return group.status === WEIGHED_STATUS
}

function hasPlatesFor (group, calorieId) {
  return ((group.plates_by_calorie || {})[calorieId] || 0) > 0
}

export function isRawPortionedGroup (group) {
  return group.is_raw_portioned === true
}

export function isWeighableGroup (group) {
  return group.is_weighable !== false && !isRawPortionedGroup(group)
}

export function isZeroWeightGroup (group) {
  return !isWeighableGroup(group) && !isRawPortionedGroup(group)
}

function isSummingGroup (group) {
  return !isZeroWeightGroup(group)
}

export function buildCalorieColumns (calories) {
  return Object.keys(calories)
    .sort((first, second) => calories[first] - calories[second])
    .map((calorieId) => ({ calorieId, kcal: calories[calorieId] }))
}

function hasServingGrams (group, calorieId) {
  return hasValue((group.serving_grams_by_calorie || {})[calorieId])
}

export function getGroupServingGrams (group, calorieId) {
  if (!isWeighed(group) || !hasPlatesFor(group, calorieId) || !hasServingGrams(group, calorieId)) {
    return null
  }
  return group.serving_grams_by_calorie[calorieId]
}

export function getRawPortion (group, calorieId) {
  const portion = (group.raw_portions_by_calorie || {})[calorieId]
  return isRawPortionedGroup(group) && hasPlatesFor(group, calorieId) && portion ? portion : null
}

function rawPortionPlateGrams (group, calorieId) {
  const portion = getRawPortion(group, calorieId)
  if (!portion || !hasValue(portion.units) || !hasValue(portion.cooked_min_unit_grams)) {
    return 0
  }
  return Number(portion.units) * roundDownToGram(portion.cooked_min_unit_grams)
}

function plateGrams (group, calorieId) {
  if (isRawPortionedGroup(group)) {
    return rawPortionPlateGrams(group, calorieId)
  }
  const grams = getGroupServingGrams(group, calorieId)
  return grams === null ? 0 : roundDownToGram(grams)
}

function hasMealOrdersFor (groups, calorieId) {
  return groups.filter(isSummingGroup).some((group) => hasPlatesFor(group, calorieId))
}

function hasAnyPlates (group) {
  return Object.keys(group.plates_by_calorie || {}).some((calorieId) => hasPlatesFor(group, calorieId))
}

export function listPendingGroups (groups) {
  return groups.filter(isWeighableGroup).filter((group) => !isWeighed(group) && hasAnyPlates(group))
}

export function getMealRecipeGrams (groups, recipeGramsByCalorie, calorieId) {
  const recipeGrams = (recipeGramsByCalorie || {})[calorieId]
  if (!hasMealOrdersFor(groups, calorieId) || !hasValue(recipeGrams)) {
    return null
  }
  return recipeGrams
}

export function getMealTotalGrams (groups, calorieId) {
  if (!hasMealOrdersFor(groups, calorieId) || listPendingGroups(groups).some((group) => hasPlatesFor(group, calorieId))) {
    return null
  }
  return groups.filter(isSummingGroup).reduce((total, group) => total + plateGrams(group, calorieId), 0)
}
